export const CHANGE_CONTRACT = 'CHANGE_CONTRACT' as const;
export const CHANGE_BUSINESS_LINE = 'CHANGE_BUSINESS_LINE' as const;
export const CHANGE_SUBJECT_GROUP = 'CHANGE_SUBJECT_GROUP' as const;

export const changeContract = () => ({
  type: CHANGE_CONTRACT,
});

export const changeBusinessLine = () => ({
  type: CHANGE_BUSINESS_LINE,
});

export const changeSubjectGroup = () => ({
  type: CHANGE_SUBJECT_GROUP,
});

export type ChangeContract = ReturnType<typeof changeContract>;
export type ChangeBusinessLine = ReturnType<typeof changeBusinessLine>;
export type ChangeSubjectGroup = ReturnType<typeof changeSubjectGroup>;
export type NewMessageActions = ChangeContract | ChangeBusinessLine | ChangeSubjectGroup;
